import { Box, Chip } from "@mui/material"
import type { FC } from "react"
import { twMerge } from "tailwind-merge"

interface CountChipProps {
  label: string
  value: string
  className?: string
  "data-testid": string
}

export const CountChip: FC<CountChipProps> = ({ label, value, className, "data-testid": testId }) => {
  return (
    <Chip
      className={twMerge(className, "h-6 rounded bg-primary-200 text-xs text-gray-900")}
      label={
        <Box component='span' className='inline-flex items-center gap-x-1.5'>
          {label}:
          <Box component='span' className='inline-block h-4 rounded bg-white px-1 text-xs' data-testid={testId}>
            {value}
          </Box>
        </Box>
      }
    />
  )
}
